import {RunWindow} from "/src/domain/challenges/ChallengeProtocolData";
import {useTranslation} from 'react-i18next';
import dayjs from "dayjs";


export const getChallengeDate = (runWindow: RunWindow): string => {
    const {t} = useTranslation()
    const startDate = dayjs(runWindow.startDate)
    const stopDate = dayjs(runWindow.stopDate)
    const stopMonth = t('months').split(',')[stopDate.get('month')];
    const startMonth = t('months').split(',')[startDate.get('month')] === stopMonth
        ? ''
        : t('months').split(',')[startDate.get('month')];

    return `${startDate.get('date')} ${startMonth} - ${stopDate.get('date')} ${stopMonth} ${stopDate.get('year')} ${t('year')}`
}